import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {ActionMeta, SingleValue} from 'react-select';
import {InvoiceOrderDocument, Option} from '../../../../common/types';
import InputTypeAhead from '../../../../common/components/ui/InputTypeAhead';
import search from '../../../../common/assets/icons/search.svg';
import styles from './InputCustomerLink.module.scss';

type InputCustomerLinkProps = {
  loadCustomerOptions: (input: string) => Promise<Option[]>
  onCustomerChanged: (input: string) => Promise<void>
  updateForm: () => void
  invoiceOrder: InvoiceOrderDocument | null
};

const InputCustomerLink = ({
                             loadCustomerOptions,
                             onCustomerChanged,
                             updateForm,
                             invoiceOrder
                           }: InputCustomerLinkProps) => {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: 'payment-form-customerLink',
    defaultMessage: 'Existing customer link'
  });
  const placeholder = intl.formatMessage({
    id: 'common-select-label',
    defaultMessage: 'Select'
  });
  const [fieldCustomerLink, metaCustomerLink, helperCustomerLink] = useField({name: 'customerLink'});
  const [/*fieldCustomerID*/, /*metaCustomerID*/, helperCustomerID] = useField({name: 'customerID'});
  const [fieldCustomerName] = useField({name: 'customerName'});
  const [fieldInvoice, /*metaInvoice*/, helperInvoice] = useField({name: 'invoiceID'});

  const handleChange = (customer: SingleValue<Option>, actionMeta: ActionMeta<Option>) => {
    helperCustomerLink.setValue(customer?.value || '');
    helperCustomerID.setValue(customer?.value || '');
    helperInvoice.setValue('');
    if (actionMeta.action === 'clear') {
      Boolean(invoiceOrder?.customerID)
        ? updateForm()
        : helperCustomerID.setValue('');
    }
    if (customer?.value && customer?.value !== fieldCustomerLink.value) {
      onCustomerChanged(customer.value).catch(console.error);
    }
  };

  const inputValue = fieldCustomerLink?.value
    ? {
      label: [fieldCustomerLink.value, fieldCustomerName.value].filter(Boolean).join(' - '),
      value: fieldCustomerLink.value
    }
    : {label: '', value: ''};

  return (
    <div className={styles.selectContainer}>
      <InputTypeAhead
        <Option, false>
        {...fieldCustomerLink}
        {...metaCustomerLink}
        id={fieldCustomerLink.name}
        value={inputValue}
        label={label}
        placeholder={placeholder}
        loadOptions={loadCustomerOptions}
        onChange={handleChange}
        customClassnames={{
          control: styles.control,
          label: styles.label
        }}
        isDisabled={Boolean(fieldInvoice.value)}
      />
      <img
        src={search}
        alt="search"
        className={styles.searchIcon}
      />
    </div>
  );
};

export default InputCustomerLink;
